/**
 * Exhaustiveness guard. Call in the `default` branch of a switch over a union so
 * that adding a new member becomes a compile error rather than a silent fallthrough.
 *
 * The capability and role switches in IM-13 depend on this, which is why it lands here.
 */
export const assertNever = (value, context) => {
    const where = context ? ` in ${context}` : '';
    throw new Error(`Unhandled union member${where}: ${JSON.stringify(value)}`);
};
/**
 * Narrows away null/undefined at a boundary where the type system cannot prove
 * presence — a lookup result, an env var, an optional field the caller guaranteed.
 */
export const assertDefined = (value, name) => {
    if (value === null || value === undefined) {
        throw new Error(`Expected ${name} to be defined`);
    }
    return value;
};
//# sourceMappingURL=assert.js.map